import Swal from 'sweetalert2';
import { project } from '../../../store';
let p = null;
project.subscribe(m => (p = m));
export class RecoveryModule {
    _htmlElement = null;
    requestRecovery() {
        return new Promise((resolve, reject) => {
            Swal.fire({
                title: 'Recover unsaved work?',
                text: 'You have unsaved work. Would you like to recover it?',
                icon: 'question',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Yes',
                denyButtonText: 'No'
            }).then(result => {
                if (result.isConfirmed) {
                    resolve(true);
                }
                else if (result.isDenied) {
                    resolve(false);
                }
                else {
                    resolve(false);
                }
            });
        });
    }
    async savePreview() { }
    async setElement(domElement) {
        if (this._htmlElement !== null)
            this._htmlElement = null;
        this._htmlElement = domElement;
    }
    async recover() { }
    async markSaved() { }
    async hasUnsavedWork() {
        return false;
    }
    async reset() { }
}
let m = null;
export function getRecoveryModule() {
    if (!m)
        m = new RecoveryModule();
    return m;
}
